import { forwardRef, type ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'ghost' | 'danger';
type Size = 'sm' | 'md';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const base =
  'inline-flex items-center justify-center gap-2 font-bold cursor-pointer transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-sans';

const variants: Record<Variant, string> = {
  primary:
    'bg-gradient-to-br from-orange to-amber text-white border border-transparent shadow-glow-sm hover:shadow-glow-lg hover:brightness-110',
  ghost:
    'bg-transparent text-ink-3 border border-glass-border hover:bg-glass-2 hover:text-ink',
  danger:
    'bg-transparent text-red border border-red/20 hover:bg-red-bg',
};

const sizeClasses: Record<Size, string> = {
  sm: 'text-[10px] px-3 py-1 rounded-md',
  md: 'text-xs px-5 py-2 rounded-md',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className = '', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`${base} ${variants[variant]} ${sizeClasses[size]} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
